import * as React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import Img from 'components/common/Img'

const HeroQRCode = ({ _rawContent, qrCode, qrCodeUrl, bgImage }) => (
	<section className="relative bg-suede-black text-white">
		<Img
			className="pointer-events-none !absolute inset-0 size-full opacity-20 grayscale"
			image={bgImage}
			objectFit="cover"
		/>

		<div className="relative mx-auto grid max-w-screen-xl items-center gap-8 px-8 py-12 md:grid-cols-2 <md:px-4">
			<div className="richtext [&_h2]:h1">
				<SanityBlock body={_rawContent} />
			</div>

			<figure className="mx-auto max-w-[300px] bg-white p-4">
				<a href={qrCodeUrl}>
					<Img image={qrCode} alt="QR code" />
				</a>
			</figure>
		</div>
	</section>
)

export default HeroQRCode
